<template>
  <div style="display: flex;">
    <div style="padding: 0 20px;">
      <!-- 说明 -->
      <div>
        <div style="line-height: 24.5px;margin: 20px 0;">{{$I18n("set_app_icon")}} <i class="warn-icon">{{$I18n("must_match")}}</i></div>
        <div class="sub-info">{{$I18n("import_info_01")}}</div>
      </div>
      <!-- 添加图片 -->
      <div style="position:relative;">
        <div @click="clickInput" class="icon-image-select-box-one">
          <div v-if="!isuploadimage && mouseMove" class="image-box-info" :class="hasIcon ? 'hidden-mode' :''">
            <div class="button">{{$I18n("upload_img")}}</div>
            <div class="span">{{$I18n("image_require_w_h_size").replace("%a%", '1024').replace("%b%", '1024').replace("%c%", '1MB')}}</div>
          </div>
          <div v-if="hasIcon" class="img">
            <img :src="appImgIcon.urls[0].url"/>
          </div>
        </div>
        <div v-if="isuploadimage" class="loading loading-container" >
          <div>
            <i class="iconfont load-icon-small" :style="{transform: `rotate(${rotatedeg}deg)`}">&#xe61e;</i>
          </div>
        </div>
      </div>
      <input style="display: none;" ref="file_input" type="file" @change="onFileChange" />
    </div>
    <!-- 图片展示 -->
    <div style="flex:1;text-align: center;">
      <phone-one :icon_src="hasIcon ?appImgIcon.urls[0].url :''"/>
      <div style="text-align: center;">
        {{$I18n("import_info_02")}}
      </div>
    </div>
  </div>
</template>
<script>
import PhoneOne from './PhoneOne.vue';
export default {
  name: "res-mng",
  components: { PhoneOne },
  props: {
    app_id : {
      type: Number,
      default: 0,
    },
  },
  data(){
    return {
      // 
      isuploadimage: false,   // 是否正在上传图片
      mouseMove: true,        // 鼠标重新移动了
      intervalUploadImage: 0, // 定时器 Interval
      rotatedeg: 0, // loarding角度
      // 
      appImgIcon : {
        state: 1,
        urls : [{
          url: "",
          type: 1,
          lang: "en",
          other_lang: "",
        }],
      },
    }
  },
  mounted(){
    this.api_getUrl()
      .then(() => {
        if(!this.appImgIcon.id){
          this.$api.addAppImgUrl({
            master_id: this.app_id,
            state    : 1,
            key      : "icon",
            urls     : [],
          })
            .then(() => {
              this.api_getUrl();
            })
        }
      })
    document.addEventListener('mousemove', this.handleMouseMove);
  },
  beforeDestroy(){
    document.removeEventListener('mousemove', this.handleMouseMove);
    clearInterval(this.intervalUploadImage)
  },
  watch:{
    // 启动、关闭 loading 转圈
    isuploadimage(newValue){
      if(newValue){
        this.intervalUploadImage = setInterval(() => {
          this.rotatedeg = this.rotatedeg + 10;
          if(this.rotatedeg > 360){
            this.rotatedeg = this.rotatedeg - 360
          }
        } , 30)
      } else {
        clearInterval(this.intervalUploadImage);
        this.rotatedeg = 0;
      }
    },
  },
  methods:{
    api_getUrl(){
      return this.$api.getAppImgUrl({ // api: /user/app/img/get
        master_id: this.app_id,
        key      : "icon",
      })
        .then(this.$Then(res => {
          if(res.data.length == 0){
            return
          }
          this.appImgIcon = {
            ...res.data[0],
            urls: res.data[0].urls? res.data[0].urls :[],
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    // 防止hover在上传文件后依旧存在
    handleMouseMove(){
      this.mouseMove = true;
    },
    // 上传ICON
    onFileChange(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files  || !files.length) return;
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.appImgIcon.urls[0].url = e.target.result;
      };

      var formData = new FormData();

      if(!files[0].type.includes("png") || files[0].size > 1024 * 1024){
        return 
      }
      this.isuploadimage = true;
      this.mouseMove = false;
      formData.append('myfile', files[0]);
      this.$api.uploadFile(formData)
        .then(this.$Then(res => {
          reader.readAsDataURL(files[0]);
          return this.$api.setAppImgUrl({
            id: this.appImgIcon.id,
            master_id: this.app_id,
            state: 1,
            key: "icon",
            urls: [{
              ...this.appImgIcon.urls[0],
              url: res.data,
            }],
          });
        }))
        .then(() => {
          this.api_getUrl();
        })
        .catch(this.$Catch(this.$I18n("get_error")))
        .then(() => {this.isuploadimage = false})
    },
    // 点击 - 提交图片
    clickInput(){
      this.$refs.file_input.click();
    },
    // 设置app_img_icon
    setAppImgIcon(data){
      this.appImgIcon = {
        ...data,
        urls : data.urls.map(item => {
          return {
            ...item
          }
        }),
      }
    },
  },
  computed:{
    hasIcon(){
      return this.appImgIcon.urls.length > 0 && this.appImgIcon.urls[0].url
    }
  },
}
</script>
<style scoped>
  
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }

  .loading{
    top: 4px;
    width: 128px;
    height: 128px;
    position: absolute;
    z-index: 2;
    background: rgba(255,255,255,.7);
    top:  1px;
    left: 1px;
    border-radius: 6px;
  }
  .image-box-info{
    display: inline-flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    padding: 8px;
  }
  .image-box-info.hidden-mode{
    background: rgba(30,30,30,.4);
    opacity: 0;
    border-radius: 8px;
    transition: opacity 0.3s ease;
  }
  .image-box-info.hidden-mode .button,
  .image-box-info.hidden-mode .span{
    color: #FFFFFF !important;
    border-color: #FFFFFF !important;
  }
  .image-box-info.hidden-mode:hover{
    opacity: .9;
  }

  .hidden-mode .span,
  .hidden-mode .button{
    color: #FFFFFF;
    border-color: #FFFFFF;
  }
</style>


<style scoped>
.sub-info{
  color: #576175;
  font-size: 10px;
  line-height: 16px;
  margin-bottom: 20px;
}
.warn-icon{
  align-items: center;
  background: #fdded8;
  border-radius: 20px;
  color: #f94346;
  display: inline-flex;
  flex-direction: row;
  font-size: 12px;
  font-weight: 400;
  justify-content: center;
  line-height: 18px;
  margin-left: 4px;
  padding: 1px 8px;
}
.loading-container{
  height: 128px;
  width: 128px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
}
.load-icon-small{
    color: #00bcd4 !important;
    font-size: 50px !important;
    display: inline-block;
    line-height: 50px;
}



.icon-image-select-box-one{
  border: 1px solid rgba(0,0,0,.1);
  width: 130px;
  height: 130px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;
}
.icon-image-select-box-one .span{
  color: rgba(0, 0, 0, .4);
  font-size: 10px;
  font-weight: 600;
  line-height: 12px;
  text-align: center;
}
.icon-image-select-box-one .img{
  margin: -8px;
  width: 130px;
  height: 130px;
  position: absolute;
  z-index: -1;
}
.icon-image-select-box-one .button{
  align-items: center;
  border: 1px solid rgba(15, 115, 230, .4);
  border-radius: 6px;
  color: #0f73e6;
  cursor: pointer;
  display: inline-flex;
  flex-direction: column;
  font-size: 12px;
  font-weight: 600;
  height: unset;
  line-height: 14px;
  margin-bottom: 10px;
  padding: 2px 10px;
}
.setting-btn{
  position: absolute;
  right: 0;
  top: 0;
  background: rgba(50, 50, 50, .2);
  padding: 3px;
  border-radius: 7px;
  font-size: 16px !important;
  cursor: pointer;
}
.setting-btn:hover{
  background: rgb(50,50,50,.7);
}
.setting-btn:hover /deep/ .md-icon.md-theme-default.md-icon-font{
  color: #FFF;
}
.setting-btn-icon{
  font-size: 16px !important;
}
img{
  width: 100%;
  height: 100%;
}
.no-animate{
  transition: none !important;
}
.hide-label /deep/ label{
  opacity: 0 !important;
}
</style>